<template>
    <Head title="Mes demandes d'envoie de colis" />

    <FrontLayout>
        <div class="w-full text-xl text-gray-800 leading-normal mb-6">
            <h1 class="font-bold font-sans break-normal text-gray-900 pt-6 text-3xl md:text-4xl">
                Mes demandes d'envoi de colis
            </h1>
            <p class="text-sm font-normal text-gray-600 flex items-center">
                    <svg class="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24">
                    <path class="text-sky'" d="M14.5 7c4.695 0 8.5 3.184 8.5 7.111 0 1.597-.638 3.067-1.7 4.253V23l-4.108-2.148a10 10 0 01-2.692.37c-4.695 0-8.5-3.184-8.5-7.11C6 10.183 9.805 7 14.5 7z"></path>
                    <path class="text-sky-300'" d="M11 1C5.477 1 1 4.582 1 9c0 1.797.75 3.45 2 4.785V19l4.833-2.416C8.829 16.85 9.892 17 11 17c5.523 0 10-3.582 10-8s-4.477-8-10-8z"></path>
                </svg>
                Tableau récapitulatif des demandes d'envoie de colis chez Boti Cargo Shipping.
            </p>
        </div>
            <div x-data="handleSelect mb-6">
                <Datatables>
                    <template #title>
                        Liste de mes demandes
                        <span class="font-medium">({{ requests.total }})</span>
                    </template>

                    <template #headerButtons>
                        <div class="grid grid-flow-col sm:auto-cols-max sm:justify-end gap-2">
                            <button class="rounded-md py-0 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                                @click="showSearchModal"
                            ><i  class="fad fa-search cursor-pointer"></i></button>
                        </div>
                    </template>

                    <template #tableHeader>
                        <th>Code</th>
                        <th>Envoyée le</th>
                        <th>Nombre de colis</th>
                        <th>Statut</th>
                        <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                            <span class="sr-only">Menu</span>
                        </th>
                    </template>
                    <template #tableBody>
                        <template v-for="(req, index) in requests.data" :key="index">
                            <tr>
                                <td class="whitespace-nowrap">{{ req.code }}</td>
                                <td class="capitalize">{{ formattedDateTime(req.created_at) }}</td>
                                <td class="whitespace-nowrap">
                                    {{ req.weight_package ? req.weight_package : 'Non défini' }}
                                </td>
                                <td class="whitespace-nowrap">
                                    <div class="inline-flex font-medium rounded-full text-center px-2.5 py-0.5"
                                        :class="'bg-'+req.status_color+'-100 text-'+req.status_color+'-500 border border-'+req.status_color+'-500'"
                                    >{{ req.status_text }}</div>
                                </td>
                                <td class="whitespace-nowrap">
                                    <div class="flex justify-end">
                                        <i @click.prevent="openDetails(req)" aria-controls="description-02"
                                            class="fad fa-arrow-down text-sm text-sky hover:text-sky-400 transform
                                            cursor-pointer transition-transform duration-200 ease-in-out"
                                            :class="{ 'rotate-180' : selectedRequest && selectedRequest.id === req.id }"
                                            :title="selectedRequest && selectedRequest.id === req.id ? 'Cacher' : 'Détails'"
                                        ></i>
                                    </div>
                                </td>
                            </tr>
                            <tr id="description-02" role="region" v-show="selectedRequest && selectedRequest.id === req.id">
                                <td colspan="10">
                                    <div class="w-full my-1 bg-gray-100 p-2">
                                        <div class="text-left text-sm px-4 text-gray-500">
                                            <span class="font-bold ">Description du colis:</span> {{ req.description ?? 'Non renseigné' }}
                                        </div>
                                        <hr class="my-2">
                                        <div class="text-left text-sm px-4 text-gray-500">
                                            <span class="font-bold ">Adresse de récupération:</span> {{ req.address ?? 'Non renseigné' }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </template>
                </Datatables>
            </div>

        <Pagination :links="requests.links" />

        <JetDialogModal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Rechercher une demande</template>
            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </JetDialogModal>
    </FrontLayout>
</template>

<script>
    import { Head } from '@inertiajs/inertia-vue3';
    import Datatables from '@/Components/Datatables'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import DateFormatMixins from '@/Mixins/DateFormatMixins'
    import SearchActionMixins from '@/Mixins/SearchActionMixins'

    export default {
        components: {
            Head,
            Datatables,
            FrontLayout,
            GlobalFilter,
            JetDialogModal
        },

        mixins: [CurrencyMixins, SearchActionMixins, DateFormatMixins],

        props: {
            requests: Object
        },

         data() {
            return {
                selectedRequest: null
            }
        },

        methods:{
            openDetails(req) {
                if (this.selectedRequest && this.selectedRequest.id === req.id) {
                    this.selectedRequest = null;
                } else {
                    this.selectedRequest = req
                }
            },
        }
    }
</script>

